module.exports = __webpack_public_path__ + "static/media/Hoja_Sala_SOMA_RatAttack.711620cd.pdf";